import React from "react";
import * as S from "./styles";
import { Title } from "../../Atoms/Title";
import { useLogin } from "./useLogin";
import { FormLogin } from "../../Molecules/FormLogin";

export const LoginTemplate = () => {
  const { onSubmitForm } = useLogin();

  return (
    <S.Container>
      <div className="max-w-5xl mx-auto">
        <div className="mb-8">
          <Title className="!mb-4">LOGIN</Title>
          <p className="text-lg text-center sm:text-start">
            Entre com seus dados de acesso.
          </p>
        </div>
        <FormLogin onSubmitForm={onSubmitForm} />
      </div>
    </S.Container>
  );
};
